import React, { FC, memo } from 'react';
import { Grid } from '@mui/material';
import {
  LoginHead,
  LoginInner,
  LoginWrapper,
  StyledContainer,
  StyledHeading,
  StyledLogo,
  StyleItemGrid,
} from 'layouts/AuthLayout/styled';
import { AuthLayoutProps } from 'layouts/AuthLayout/types';

const AuthLayout: FC<AuthLayoutProps> = ({ title, isMobile, children }) => {
  return (
    <LoginWrapper>
      <Grid container spacing={1} height='100%'>
        <StyleItemGrid item xl={12} lg={12} md={12} sm={12}>
          <LoginInner>
            <LoginHead>
              <StyledLogo />
            </LoginHead>

            <StyledContainer>
              <StyledHeading variant={isMobile ? 'h5' : 'h4'}>{title}</StyledHeading>
              {children}
            </StyledContainer>
          </LoginInner>
        </StyleItemGrid>
      </Grid>
    </LoginWrapper>
  );
};

export default memo(AuthLayout);
